module.exports = __webpack_public_path__ + "img/product_117.4a3c92a.webp";